// extracted by mini-css-extract-plugin
export default {"centerText":"camera-and-microphone-permission-denied-message-module__centerText--eL5ap","wrapper":"camera-and-microphone-permission-denied-message-module__wrapper--ptI4n"};